<template lang="pug">
    section
        v-card(v-if="loading")
            v-skeleton-loader(v-if="loading" type="table")
        v-card(v-else)
            v-card-subtitle Изменения состава портфеля
            v-card-text
                v-data-table.elevation-0.mt-1(
                    :headers='tableHeaders'
                    fixed-header
                    :loading="tableLoading"
                    item-key="id"
                    :items-per-page="10"
                    :items='portfolioChanges'
                    :server-items-length="pagination.totalItems"
                    :options.sync="options"
                    :pageCount="pagination.numberOfPages"
                )
                    template(v-slot:item.action="{ item }")
                        span(v-if="item.action === 'BUY'").amber--text.text--darken-2 Покупка
                        span(v-if="item.action === 'SELL'").teal--text.text--lighten-2 Продажа
                    template(v-slot:item.date="{ item }") {{ item.date | formatDateToLocale }}
                    template(v-slot:item.cost="{ item }")
                        span(v-if="item.action === 'BUY'").deep-orange--text.text--lighten-2 -{{ item.order.symbol.price_buy * item.order.count | toUSD }}
                        span(v-if="item.action === 'SELL'").teal--text.text--lighten-2 {{ item.order.cost * item.order.count | toUSD }}
                    template(v-slot:item.portfolio_cost="{ item }") {{ calc_portfolio_cost(item) | toUSD }}
                    template(v-slot:item.portfolio="{ item }")
                        apexchart(type="bar" height="40" :options="getPortfolioChangesChartOptions(item)" :series="getPortfolioChangesChartSeries(item)")

</template>

<script>
  import ClientApi from '@/api/client';
  import VueApexCharts from 'vue-apexcharts';

  export default {
    name: 'ClientPortfolioChanges',
    components: {
      'apexchart': VueApexCharts,
    },
    computed: {},
    watch: {
      'options': async function (newVal, oldVal) {
        if (oldVal && this.first_init) {
          await this.getClientPortfolioChanges()
        }
      },
    },
    data() {
      return {
        first_init: false,
        loading: true,
        tableLoading: false,
        portfolioChanges: [],
        options: {
          sortDesc: [true],
          sortBy: ['date'],
          itemsPerPage: 10,
          page: 1
        },
        pagination: {
          next: null,
          totalItems: 0,
          numberOfPages: 0,
          currentPage: 0
        },
        tableHeaders: [
          {
            text: 'Тип операции',
            align: 'start',
            sortable: true,
            value: 'action',
            fixed: true,
            width: '1%',
          },
          // {
          //   text: 'Сумма',
          //   align: 'start',
          //   sortable: true,
          //   value: 'amount',
          //   fixed: true,
          //   width: '1%',
          // },
          {
            text: 'Дата',
            align: 'start',
            sortable: true,
            value: 'date',
            fixed: true,
            width: '1%',
          },
          {
            text: 'Отрасль',
            align: 'start',
            sortable: true,
            value: 'order.symbol.sector',
            fixed: true,
            width: '1%',
          },
          {
            text: 'Изм. баланса',
            align: 'start',
            sortable: true,
            value: 'cost',
            fixed: true,
            width: '1%',
          },
          {
            text: 'Объем портфеля',
            align: 'start',
            sortable: true,
            value: 'portfolio_cost',
            fixed: true,
            width: '1%',
          },
          {
            text: 'Состав',
            align: 'start',
            sortable: true,
            value: 'portfolio',
            fixed: true,
            width: '100%',
          },
        ],
      };
    },
    async created() {
      await this.getClientPortfolioChanges();
      this.loading = false;
      this.first_init = true
    },
    methods: {
      getChartColors(item) {
        let sectorsList = [];
        Object.keys(item.portfolio).forEach(k => {
          sectorsList.push(k.toLowerCase());
        });
        const colors = this.$store.getters.sector_colors(sectorsList);
        return colors;
      },
      calc_portfolio_cost(item) {
        let portfolio_cost = 0;
        Object.values(item.portfolio).forEach(v => {
          portfolio_cost += v;
        });
        return portfolio_cost;
      },
      async getClientPortfolioChanges() {
        this.tableLoading = true;
        const {page, itemsPerPage, sortBy, sortDesc} = this.options;
        let pageNumber = page - 1;
        try {
          const response = await ClientApi.getClientPortfolioChanges(
              {
                'client_id': this.$store.state.auth.user.id,
                'offset': itemsPerPage * pageNumber,
                'limit': itemsPerPage,
                'sort': sortDesc[0] ? `-${sortBy[0]}` : sortBy[0],
              },
          );
          this.portfolioChanges = response.data;
          this.pagination.totalItems = response.total_count;
          this.pagination.numberOfPages = Math.ceil(response.total_count / itemsPerPage);
        } catch (err) {
          console.log(err.data);
        }
        this.tableLoading = false
      },
      getPortfolioChangesChartSeries(item) {
        const portfolio = item.portfolio;
        let series = [];
        Object.keys(portfolio).forEach(k => {
          series.push({'name': k, 'data': [portfolio[k]]});
        });
        return series;
      },
      getPortfolioChangesChartOptions(item) {
        const labels = Object.keys(item.portfolio);
        return {
          chart: {
            type: 'bar',
            height: 40,
            stacked: true,
            stackType: '100%',
            // parentHeightOffset: 10,
            toolbar: {
              show: false,
            },
            sparkline: {
              enabled: true,
            },
            animations: {
              enabled: false,
            },
          },
          colors: this.getChartColors(item),
          legend: {
            show: false,
            showForSingleSeries: true,
            offsetY: 10,
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          xaxis: {
            labels: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            lines: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            labels: {
              show: false,
            },
            lines: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
          grid: {
            show: false,
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
          labels: labels,
          tooltip: {
            x: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  height: 150,
                  sparkline: {
                    enabled: false,
                  },
                },
                xaxis: {
                  labels: {
                    show: true,
                  },
                  axisTicks: {
                    show: true,
                  },
                  lines: {
                    show: true,
                  },
                  axisBorder: {
                    show: true,
                  },
                },
                legend: {
                  show: true,
                  showForSingleSeries: true,
                  offsetY: 10,
                },
              },
            }],
        };
      },
    },
  };
</script>

<style scoped>

</style>